import * as d3 from 'd3';
import { ChartDataArray } from '../data/ChartDataArray';
import { DataRenderer } from './DataRenderer';

export abstract class StackedRenderer extends DataRenderer {
  constructor(private filled: boolean) {
    super();
  }

  protected createSeries(arrays: ChartDataArray[], keys: string[], limit?: number, inverted?: boolean) {
    const reversed = [...arrays].reverse();
    const stack = d3.stack().keys(reversed.map(array => array.label));

    const columnTotals: number[] = [];
    if (this.filled) {
      keys.forEach((_key, i) => {
        columnTotals[i] = 0;
        reversed.forEach(array => {
          columnTotals[i] += Math.max(0, array.getData(limit, inverted)[i].value!);
        });
      });
    }
    const data = keys.map((key, i) => {
      const res: any = {};
      reversed.forEach(array => {
        const value = array.getData(limit, inverted)[i].value!;
        res[array.label] = this.filled ? Math.max(value, 0) / columnTotals[i] : value;
      });
      res.label = key;
      return res;
    });
    stack.offset(d3.stackOffsetDiverging);

    const series = stack(data);
    return series;
  }

  protected static getKeys(arrays: ChartDataArray[], limit?: number, inverted?: boolean): string[] {
    const keySet = new Set<string>();
    arrays.forEach(array =>
      array.getData(limit, inverted).forEach(data => {
        keySet.add(data.label!);
      })
    );
    return Array.from(keySet);
  }
}
